import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Input,
  notification,
  Modal,
  Checkbox,
} from "antd";
import { Link, useLocation } from "react-router-dom";
import LoginPic from "../assets/images/tahsilat-glass-logo-png.png";
import Screen from "../util/Extensions/Screens";
import { useSelector } from "react-redux";
import RequestHandler from "../util/RequestHandler";
import RegisterPic from "../assets/images/tahsilat_screen3.png";
import ParaticPhoneInput from "../routes/Forms/Helper/RegisterPhoneInput";

const SignUp = (props) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [visible, setVisible] = useState(false);
  const [otpType, setOtpType] = useState("");
  const [mailLogin, setMailLogin] = useState("");
  const [psr, setPsr] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const { initialMinute = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(180);
  const [errorText, setErrorText] = useState("");
  const [confidentialAgreement, setconfidentialAgreement] = useState(
    "/KVKKAydınlatmaMetni.pdf"
  );
  const [salesAgreement, setSalesAgreement] = useState(
    "/TahsiliteHizmetSözleşmesi.pdf"
  );
  const [registerLoading, setRegisterLoading] = useState(false);
  const params = new URLSearchParams(location.search);
  const [utmCampaign, setUtmCampaign] = useState(null);
  const [businessPartnerId, setBusinessPartnerId] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          handleCancel();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const showModal = (otpType) => {
    setOtpType(otpType);
    setSeconds(180);
    setOtpInput("");
    setErrorText("");
    setVisible(true);
  };

  const handleSubmit = (values) => {
    RequestHandler.post(
      `/Auth/Login`,
      {
        email: mailLogin,
        password: psr,
        screenOption: Screen.screen,
        securityKey: values.otp,
      },
      false
    ).then((response) => {
      if (response.success) {
        setLoading(false);
        RequestHandler.setUserInfo(response);
        window.location.reload();
      } else {
        setLoading(false);
        setLoadingBtn(false);
      }
    });
  };

  const handleCancel = () => {
    if (handleCancel) {
      setLoading(false);
    }
    setVisible(false);
    setLoadingBtn(false);
  };

  const token = useSelector(({ auth }) => auth.token);
  const onFinishFailed = () => setLoading(false);

  const onFinish = (values) => {
    // axios.get(`${config.apiUrl}/Auth/PsrControl?email=${values.email}`).then(({data}) => {
    //     if(data === null || data === ""){
    RequestHandler.post(
      `/Auth/Login`,
      {
        email: values.email,
        password: values.password,
        screenOption: Screen.screen,
      },
      false
    ).then((response) => {
      if (response.success) {
        if (response.message === "smsOtp" || response.message === "mailOtp") {
          showModal(response.message);
          setMailLogin(values.email);
          setPsr(values.password);
        } else {
          RequestHandler.setUserInfo(response);
          openNotificationWithIcon("success");
          window.location.reload();
        }
      } else {
        setLoading(false);
      }
    });
    // }else{
    //   props.history.push(`/reset-password/${data}/true`);
    // }
    // }).catch(function (error) {
    //   if(error.response.status === 406){
    //     error.response.data.data.map((item)=>{
    //       errorList.push(item);
    //     })
    //     errorListNotification('error')
    //     setLoadingBtn(false)
    //     setLoading(false)
    //     }else{
    //         sameError('error')
    //         setLoading(false)
    //         setLoadingBtn(false)
    //     }
    //   });
  };

  const onChangePsrLoginValue = (e) => {
    setErrorText("");
    setOtpInput(e.target.value);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Giriş işlemi başarılı.",
      duration: 2,
    });
  };

  const openNotificationRegister = (type, description) => {
    notification[type]({
      message: "BAŞARILI",
      description: description,
      duration: 5,
    });
  };

  const ref = useRef();

  useEffect(() => {
    if (token !== null) {
      if (location.state && location.state.from) {
        props.history.push(location.state.from.pathname);
      } else {
        props.history.push("/home");
      }
    }
  }, [token, props.history]);

  const handleRegister = (values) => {
    setRegisterLoading(true);
    RequestHandler.post(
      `/WebSite/TenantRegisterFromSignin`,
      {
        email: values.registerEmail,
        password: values.registerPassword,
        screenOption: Screen.screen,
        name: values.companyName,
        firstName: values.firstName,
        lastName: values.lastName,
        moduleIds: [6, 8],
        vkn: values.vknTckn,
        phoneNumber: values.phone?.slice(2),
        businessPartnerId: businessPartnerId,
        utmCampaign: utmCampaign,
      },
      false
    ).then((response) => {
      setRegisterLoading(false);
      if (response.success) {
        form.resetFields();

        if (response?.message === "true") {
          openNotificationRegister(
            "success",
            "Hesabınız oluşturuldu.Mevcut bilgilerinizle giriş yapabilirsiniz."
          );
        } else {
          openNotificationRegister(
            "success",
            "Artık Hazırsınız! Hesabınız başarıyla oluşturuldu."
          );
        }

        setTimeout(() => {
          props.history.push("/signin");
        }, 5000);
      }
    });
  };

  useEffect(() => {
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaignParam = params.get("utm_campaign");

    if (utmSource) {
      setBusinessPartnerId(utmSource);
      setUtmCampaign(utmCampaignParam);
    }
    // Google Analytics'e UTM parametrelerini gönder
    if (
      utmSource &&
      utmMedium &&
      utmCampaignParam &&
      typeof window.gtag === "function"
    ) {
      window.gtag("event", "sign_in", {
        event_category: "utm_campaign",
        event_label: `${utmSource} - ${utmMedium} - ${utmCampaign}`,
      });
    }
  }, []);

  return (
    <div className="flex h-screen">
      <Col xs={24} md={24} lg={24}>
        <Row>
          {/* Resim - Orijinal halinde kalıyor */}
          <Col xs={0} md={12} lg={12} style={{ padding: 0, margin: 0 }}>
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={RegisterPic}
                alt="Tahsilite"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "inherit",
                }}
              />
            </div>
          </Col>

          {/* Kayıt Formu */}
          <Col
            xs={24}
            md={12}
            lg={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="gx-register-container"
              style={{ width: "100%", position: "relative" }}
            >
              <Col xs={24} md={24} lg={24}>
                <div className="gx-login-content">
                  {/* Giriş Yap Linki */}
                  <p style={{ textAlign: "right", marginBottom: "10%" }}>
                    Hesabın var mı?{" "}
                    <Link
                      to="/signin"
                      style={{
                        color: "#0253f4",
                        fontWeight: "bold",
                        marginBottom: "10%",
                      }}
                    >
                      Giriş Yap
                    </Link>
                  </p>
                  <div className="gx-login-header gx-text-left">
                    <h1 className="gx-login-title">
                      <img
                        src={LoginPic} // Burada istediğiniz resmi kullanın
                        alt="Tahsilite"
                        style={{
                          width: "60%",
                          marginRight: "3%",
                        }}
                      />
                    </h1>
                  </div>
                  <h1 style={{ "font-size": "large" }}>
                    Ücretsiz Online Tahsilat Çözümü!
                  </h1>
                  <h2 style={{ "font-size": "medium" }}>
                    Ödeme alma süreçlerinizi hızlandırın, güvenli ve kolay
                    tahsilat çözümlerini keşfedin!
                  </h2>
                  <br></br>
                  <Form
                    name="register"
                    className="gx-register-form"
                    onFinish={handleRegister}
                    form={form}
                  >
                    <p style={{ fontSize: "x-large" }}>Kayıt Ol</p>
                    <Form.Item
                      name="companyName"
                      rules={[
                        { required: true, message: "Firma Unvanı zorunludur!" },
                      ]}
                    >
                      <Input placeholder="Firma Unvanı" />
                    </Form.Item>
                    <Form.Item
                      name="firstName"
                      rules={[{ required: true, message: "Ad zorunludur!" }]}
                    >
                      <Input placeholder="Ad" />
                    </Form.Item>
                    <Form.Item
                      name="lastName"
                      rules={[{ required: true, message: "Soyad zorunludur!" }]}
                    >
                      <Input placeholder="Soyad" />
                    </Form.Item>
                    <Form.Item
                      name="phone"
                      rules={[
                        {
                          required: true,
                          message: "Telefon Numarası zorunludur!",
                          min: 10,
                        },
                      ]}
                    >
                      <ParaticPhoneInput />
                    </Form.Item>
                    <Form.Item
                      name="vknTckn"
                      rules={[
                        {
                          required: true,
                          message: "Vkn/Tckn 10 veya 11 hane olmalıdır!",
                          min: 10,
                          max: 11,
                        },
                      ]}
                    >
                      <Input maxLength={11} placeholder="Vkn/Tckn" />
                    </Form.Item>
                    <Form.Item
                      name="registerEmail"
                      rules={[
                        {
                          required: true,
                          message: "Email doğru formatta olmalıdır!",
                          type: "email",
                        },
                      ]}
                    >
                      <Input placeholder="Email" autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                      name="registerPassword"
                      rules={[
                        {
                          required: true,
                          message: "Şifre zorunludur!",
                          min: 6,
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Şifre"
                        autoComplete="new-password"
                      />
                    </Form.Item>

                    <Row style={{ justifyContent: "flex-end" }}>
                      <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message:
                              "Sözleşmeleri kabul etmeniz gerekmektedir.",
                          },
                        ]}
                      >
                        <Checkbox>
                          <a href={confidentialAgreement} target="_blank">
                            Müşteri Aydınlatma Metni
                          </a>{" "}
                          ve{" "}
                          <a href={salesAgreement} target="_blank">
                            Hizmet Sözleşmesi
                          </a>{" "}
                          'ni okudum, onaylıyorum.
                        </Checkbox>
                      </Form.Item>
                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={registerLoading}
                        >
                          Kayıt Ol
                        </Button>
                      </Form.Item>
                    </Row>
                  </Form>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default SignUp;
